import { EmployerDashboardLayout } from "@js/apps/employer/views/dashboard/layout";
import { useHideRequestLoader } from "@js/hooks/use-hide-request-loader";

import { ECPViewContentLazy } from "./lazy";

import styles from "./styles.module.scss";

export const ECPPage = () => {
  useHideRequestLoader();

  return (
    <EmployerDashboardLayout
      pageTitle="Expert Contributors"
      bgcolor="var(--soft-violet)"
      setBgOnBody
      contentClassName={styles.page}
    >
      <ECPViewContentLazy />
    </EmployerDashboardLayout>
  );
};
